import styled from "styled-components";
import { Card } from "react-bootstrap";

const PRODUCT_IMAGE_SIZE = "213px";

export const StyledProductImageWrap = styled.div`
  position: relative;
  display: block;
  width: 100%;
  max-width: ${PRODUCT_IMAGE_SIZE};
  aspect-ratio: 1 / 1;
  margin: 0 auto;
  text-align: center;

  picture img,
  .carousel img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  .carousel,
  .carousel-inner,
  .carousel-item {
    width: 100%;
    height: 100%;
  }

  .carousel-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledImageAndTitle = styled(Card.Title)`
  line-height: 1.65;
  cursor: pointer;
  margin-bottom: 0;
  a {
    &:hover,
    &:active,
    &:focus {
      text-decoration: none;
    }
  }
  .product-title {
    padding-top: 20px;
    margin-bottom: 25px;
    overflow: hidden;
    height: 65px;
    letter-spacing: 1px;
    color: #000;
    font-size: 15px;
    font-weight: 700;
    text-transform: uppercase;
  }
  .variant-title {
    margin-bottom: 0;
    min-height: 21px;
    height: 21px;
    font-style: italic;
    font-weight: 100;
    letter-spacing: 1px;
    font-size: 12px;
    color: #222222;
  }
`;
